<template>
  <div class="VPanel rounded-m overflow-h shadow-small">
    <div class="VPanel__Heading p-a-m hf-bg-toned-white border-b">
      <slot name="heading" />
    </div>
    <div class="VPanel__Body p-a-m hf-bg-white">
      <slot />
    </div>
  </div>
</template>

<script>
/**
 * @module VPanel
 */
export default {
  name: 'VPanel'
}
</script>
